import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/** Kopfleiste (MUI-`AppBar`-Ersatz) auf `.sec-appbar`-Basis. */
export const AppBar = forwardRef(function AppBar({ className, ...rest }, ref) {
    return _jsx("header", { ref: ref, className: cn('sec-appbar', className), ...rest });
});
/** Inhaltszeile innerhalb einer AppBar (MUI-`Toolbar`-Ersatz). */
export const Toolbar = forwardRef(function Toolbar({ className, ...rest }, ref) {
    return _jsx("div", { ref: ref, className: cn('sec-toolbar', className), ...rest });
});
